import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    limit: 20,
    page: 1,
    total: 0,
    totalPages: 1,
};

export const inventoryPageSlice = createSlice({
    name: "inventoryPageSlice",
    initialState,
    reducers: {
        setInventoryPageLimit: (state, action) => {
            state.limit = action.payload;
        },
        setInventoryCurrentPage: (state, action) => {
            state.page = action.payload;
        },
        setInventoryTotalCount: (state, action) => {
            state.total = action.payload;
        },
        setInventoryTotalPages: (state, action) => {
            state.totalPages = action.payload;
        },
        resetInventoryPagination: (state, action) => {
            state.limit = 20;
            state.page = 1;
            state.total = 0;
            state.totalPages = 1;
        },
    },
});

export const {
    setInventoryPageLimit,
    setInventoryCurrentPage,
    setInventoryTotalCount,
    setInventoryTotalPages,
    resetInventoryPagination,
} = inventoryPageSlice.actions;

export default inventoryPageSlice.reducer;
